import { render } from "./Iconbar.vue?vue&type=template&id=8d27f79e&ts=true"
import script from "./Iconbar.vue?vue&type=script&lang=ts"
export * from "./Iconbar.vue?vue&type=script&lang=ts"

import "./Iconbar.vue?vue&type=style&index=0&id=8d27f79e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__